let defaultPageSize = 1000;

// eslint-disable-next-line import/prefer-default-export
export const getDefaultrPageSize = () => defaultPageSize;

// eslint-disable-next-line no-return-assign
global.geodisc$apiSetDefaultPageSize = value =>
  (defaultPageSize = Math.min(value, 1000));
